<div class="discount-group-offers">
  <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 mb-3">
    <div>
      <h5 class="mb-1">Discount group offers</h5>
      <p class="text-muted small mb-0">
        Mix &amp; match multi-buy: customers get the offer price when they buy the required quantity from
        <strong>any combination</strong> of products sharing the same discount group. Weighted products and
        custom-price lines are excluded from group pricing.
      </p>
    </div>
    <button type="button" class="btn btn-primary" (click)="openAddDialog()" [disabled]="loading">
      <nb-icon icon="plus-outline" class="me-1"></nb-icon>
      Add group offer
    </button>
  </div>

  <div *ngIf="loading" class="text-muted py-4 text-center">Loading discount group offers…</div>

  <div *ngIf="!loading && loadError" class="alert alert-danger">
    {{ loadError }}
    <button type="button" class="btn btn-sm btn-outline-danger ms-2" (click)="loadOffers()">Retry</button>
  </div>

  <div *ngIf="!loading && !loadError && offers.length === 0" class="text-muted py-4 text-center">
    No discount group offers yet. Assign a discount group on products, then create an offer here.
  </div>

  <div *ngIf="!loading && !loadError && offers.length > 0" class="table-responsive">
    <table class="table table-hover align-middle">
      <thead>
        <tr>
          <th style="width: 2rem"></th>
          <th>Group</th>
          <th>Name</th>
          <th>Offer</th>
          <th>Valid from</th>
          <th>Valid to</th>
          <th>Status</th>
          <th>Active</th>
          <th class="text-end">Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let offer of offers">
          <tr>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-link p-0"
                (click)="toggleExpand(offer)"
                [attr.aria-expanded]="isExpanded(offer)">
                <nb-icon [icon]="isExpanded(offer) ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
              </button>
            </td>
            <td>
              <strong>{{ offer.discountGroup }}</strong>
              <div class="text-muted small" *ngIf="groupProductCount(offer)">
                {{ groupProductCount(offer) }} product(s)
              </div>
            </td>
            <td>{{ offerDisplayName(offer) }}</td>
            <td>{{ offerSummary(offer) }}</td>
            <td>{{ formatOfferDate(offer.validFrom) }}</td>
            <td>{{ formatOfferDate(offer.validTo) }}</td>
            <td>
              <span class="badge" [ngClass]="getOfferStatus(offer).badgeClass">
                {{ getOfferStatus(offer).label }}
              </span>
            </td>
            <td>
              <nb-toggle
                [checked]="isOfferActiveToggle(offer)"
                (checkedChange)="onActiveToggle(offer, $event)"
                status="success">
              </nb-toggle>
            </td>
            <td class="text-end">
              <div class="d-flex flex-wrap justify-content-end gap-1">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="openEditDialog(offer)">
                  Edit
                </button>
                <button type="button" class="btn btn-sm btn-outline-danger" (click)="deleteOffer(offer)">
                  Delete
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="isExpanded(offer)" class="expanded-row">
            <td colspan="9">
              <div
                *ngIf="productsWithOwnOffersCount(offer) > 0"
                class="alert alert-warning py-2 px-3 small mb-2">
                {{ productsWithOwnOffersCount(offer) }} product(s) in this group have their own multi-buy offers —
                the group offer overrides them while active.
              </div>

              <div *ngIf="expandedProductsLoading" class="text-muted small py-2">Loading member products…</div>
              <div *ngIf="expandedProductsError" class="alert alert-danger py-2 px-3 small mb-0">
                {{ expandedProductsError }}
                <button type="button" class="btn btn-sm btn-outline-danger ms-2" (click)="reloadExpandedProducts(offer)">
                  Retry
                </button>
              </div>

              <div *ngIf="!expandedProductsLoading && !expandedProductsError && expandedProducts.length === 0"
                class="text-muted small py-2">
                No products in this group.
              </div>

              <div *ngIf="!expandedProductsLoading && !expandedProductsError && expandedProducts.length > 0"
                class="table-responsive member-products-table">
                <table class="table table-sm mb-0">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>SKU</th>
                      <th>Barcode</th>
                      <th>Price</th>
                      <th>Notes</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let p of expandedProducts">
                      <td>{{ p.name || '—' }}</td>
                      <td>{{ p.sku || '—' }}</td>
                      <td>{{ p.barcode || '—' }}</td>
                      <td>{{ formatCurrency(p.price) }}</td>
                      <td>
                        <span *ngIf="p.hasOwnMultiBuyOffers" class="badge bg-warning text-dark me-1">
                          Own multi-buy offer
                        </span>
                        <span *ngIf="p.soldByWeight" class="badge bg-secondary">Weighted – excluded</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
